<template>
  <section class="container mx-auto py-6 md:py-10">
    <h2 class="text-center section-heading mb-10">
      So, Are You The Qualified Person We've Been Looking For?
    </h2>

    <div class="tab flex justify-center gap-4 md:gap-8 mb-8 overflow-auto">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        class="py-3 hover:text-primary-primary hover:border-primary-primary hover:font-medium"
        :class="
          activeTab === index
            ? 'active font-medium text-primary-primary border-b-2 border-primary-primary'
            : 'font-normal text-bw-500 border-b-2 border-transparent'
        "
        @click="changeTab(tab, index)"
      >
        {{ tab.title }}
      </button>
    </div>

    <div
      class="grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-7"
      :class="careersData.length === 0 ? 'flex' : 'grid'"
    >
      <template v-if="isLoading">
        <div v-for="i in 3" :key="i" class="flex w-full">
          <div class="ml-4 flex-1">
            <UtilsSkeletonLoading class="w-full mb-2 h-7" />
            <UtilsSkeletonLoading class="w-full h-24" />
          </div>
        </div>
      </template>
      <template v-else>
        <Transition name="team">
          <div
            v-show="careersData.length === 0"
            class="w-full mx-auto px-5 mb-10 mt-4"
          >
            <p
              class="text-bw-900 font-medium text-2xl text-center w-full md:w-1/2 mx-auto"
            >
              Sorry, there are no available job openings at this time. Please
              check back later.
            </p>
          </div>
        </Transition>
        <TransitionGroup name="team">
          <NuxtLink
            v-for="(career, index) in careersData"
            v-show="careersData.length !== 0"
            :key="index"
            :to="`/careers/${career.attributes?.slug}`"
            :title="career.attributes?.title"
            class="p-6 rounded-[10px] border border-[#CECED1] hover:border-primary-primary jobs"
          >
            <h3 class="text-lg font-semibold mb-2 job-title">
              {{ career.attributes?.title }}
            </h3>
            <p class="text-sm job-type capitalize">
              {{ career.attributes?.type }}
            </p>
          </NuxtLink>
        </TransitionGroup>
      </template>
    </div>
  </section>
</template>

<script setup>
const tabs = ref([
  {
    title: 'All',
    code: 'all'
  },
  {
    title: 'Full-Time',
    code: 'full-time'
  },
  {
    title: 'Part-Time',
    code: 'part-time'
  },
  {
    title: 'Internship',
    code: 'internship'
  }
])
const activeTab = ref(0)

const isLoading = ref(true)

const careersData = ref([])

const getCareersList = async () => {
  const { data, error, pending } = await useSuitmediaApiData(`/api/careers`, {
    query: {
      'pagination[pageSize]': 40,
      'fields[0]': 'id',
      'fields[1]': 'title',
      'fields[2]': 'slug',
      'fields[3]': 'is_ats',
      'fields[4]': 'type'
      // 'sort[0]': 'order'
    },
    retry: 3,
    retryDelay: 300
  })

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Careers does not exist`
    })
  }

  return data.value
}

const careers = await getCareersList()
careersData.value = careers.data

const changeTab = (tab, index) => {
  activeTab.value = index
  isLoading.value = true

  if (tab.code === 'all') {
    isLoading.value = false
    careersData.value = careers.data
    return
  }
  careersData.value = careers.data.filter(
    item => item.attributes?.type === tab.code
  )

  isLoading.value = false
  // const career = await getCareersList(tab.code)
}
</script>

<style lang="scss" scoped>
.jobs {
  &:hover {
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);

    .job-title {
      color: #f96500;
    }
    .job-type {
      color: #f96500;
    }
  }
}

.team-enter-from {
  opacity: 0;
  translate: 0 -50px;
}
.team-enter-to {
  opacity: 1;
  translate: 0;
}
.team-enter-active {
  transition: 0.3s all ease;
}
</style>
